import { memo, useCallback } from 'react';

import { Modal } from 'components/Modal';
import { Button } from 'components/Button';

import { resetStore as resetStoreAction } from 'modules/app/actions';

import { useAction } from 'utils';

import { ReactComponent as LogoutIcon } from 'assets/images/logout.svg';

import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
};

export const LogoutModal: React.FC<Props> = memo(function LogoutModal({ onClose }) {
  const resetStore = useAction(resetStoreAction);

  const handleLogout = useCallback(() => {
    resetStore();
  }, [resetStore]);

  return (
    <Modal containerClassName={styles.container} onClose={onClose}>
      <div className={styles.logout_icon_container}>
        <LogoutIcon />
      </div>
      <h1>Log out</h1>
      <h3>Are you sure to log out?</h3>
      <div className={styles.footer}>
        <Button title="Cancel" className={styles.cancel_button} onClick={onClose} />
        <Button title="Log out" className={styles.logout_button} onClick={handleLogout} />
      </div>
    </Modal>
  );
});
